module.exports = __webpack_public_path__ + "c2082a7db86a1d80305974efef7f8700.png";